 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780062934864_COVER from '@/components/text/9780062934864_Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780062934864_TITLE from '@/components/text/9780062934864_Title'
 import TEXT9780062934864_DEDICATION from '@/components/text/9780062934864_Dedication'
 import TEXT9780062934864_CONTENTS from '@/components/text/9780062934864_Contents'
 import TEXT9780062934864_CHAPTER_1 from '@/components/text/9780062934864_Chapter_1'
 import TEXT9780062934864_CHAPTER_2 from '@/components/text/9780062934864_Chapter_2'
 import TEXT9780062934864_CHAPTER_3 from '@/components/text/9780062934864_Chapter_3'
 import TEXT9780062934864_CHAPTER_4 from '@/components/text/9780062934864_Chapter_4'
 import TEXT9780062934864_CHAPTER_5 from '@/components/text/9780062934864_Chapter_5'
 import TEXT9780062934864_CHAPTER_6 from '@/components/text/9780062934864_Chapter_6'
 import TEXT9780062934864_CHAPTER_7 from '@/components/text/9780062934864_Chapter_7'
 import TEXT9780062934864_CHAPTER_8 from '@/components/text/9780062934864_Chapter_8'
 import TEXT9780062934864_CHAPTER_9 from '@/components/text/9780062934864_Chapter_9'
 import TEXT9780062934864_CHAPTER_10 from '@/components/text/9780062934864_Chapter_10'
 import TEXT9780062934864_CHAPTER_11 from '@/components/text/9780062934864_Chapter_11'
 import TEXT9780062934864_CHAPTER_12 from '@/components/text/9780062934864_Chapter_12'
 import TEXT9780062934864_CHAPTER_13 from '@/components/text/9780062934864_Chapter_13'
 import TEXT9780062934864_CHAPTER_14 from '@/components/text/9780062934864_Chapter_14'
 import TEXT9780062934864_CHAPTER_15 from '@/components/text/9780062934864_Chapter_15'
 import TEXT9780062934864_CHAPTER_16 from '@/components/text/9780062934864_Chapter_16'
 import TEXT9780062934864_CHAPTER_17 from '@/components/text/9780062934864_Chapter_17'
 import TEXT9780062934864_CHAPTER_18 from '@/components/text/9780062934864_Chapter_18'
 import TEXT9780062934864_CHAPTER_19 from '@/components/text/9780062934864_Chapter_19'
 import TEXT9780062934864_CHAPTER_20 from '@/components/text/9780062934864_Chapter_20'
 import TEXT9780062934864_CHAPTER_21 from '@/components/text/9780062934864_Chapter_21'
 import TEXT9780062934864_CHAPTER_22 from '@/components/text/9780062934864_Chapter_22'
 import TEXT9780062934864_CHAPTER_23 from '@/components/text/9780062934864_Chapter_23'
 import TEXT9780062934864_CHAPTER_24 from '@/components/text/9780062934864_Chapter_24'
 import TEXT9780062934864_CHAPTER_25 from '@/components/text/9780062934864_Chapter_25'
 import TEXT9780062934864_CHAPTER_26 from '@/components/text/9780062934864_Chapter_26'
 import TEXT9780062934864_CHAPTER_27 from '@/components/text/9780062934864_Chapter_27'
 import TEXT9780062934864_CHAPTER_28 from '@/components/text/9780062934864_Chapter_28'
 import TEXT9780062934864_CHAPTER_29 from '@/components/text/9780062934864_Chapter_29'
 import TEXT9780062934864_CHAPTER_30 from '@/components/text/9780062934864_Chapter_30'
 import TEXT9780062934864_CHAPTER_31 from '@/components/text/9780062934864_Chapter_31'
 import TEXT9780062934864_CHAPTER_32 from '@/components/text/9780062934864_Chapter_32'
 import TEXT9780062934864_CHAPTER_33 from '@/components/text/9780062934864_Chapter_33'
 import TEXT9780062934864_CHAPTER_34 from '@/components/text/9780062934864_Chapter_34'
 import TEXT9780062934864_CHAPTER_35 from '@/components/text/9780062934864_Chapter_35'
 import TEXT9780062934864_CHAPTER_36 from '@/components/text/9780062934864_Chapter_36'
 import TEXT9780062934864_CHAPTER_37 from '@/components/text/9780062934864_Chapter_37'
 import TEXT9780062934864_CHAPTER_38 from '@/components/text/9780062934864_Chapter_38'
 import TEXT9780062934864_CHAPTER_39 from '@/components/text/9780062934864_Chapter_39'
 import TEXT9780062934864_CHAPTER_40 from '@/components/text/9780062934864_Chapter_40'
 import TEXT9780062934864_CHAPTER_41 from '@/components/text/9780062934864_Chapter_41'
 import TEXT9780062934864_CHAPTER_42 from '@/components/text/9780062934864_Chapter_42'
 import TEXT9780062934864_CHAPTER_43 from '@/components/text/9780062934864_Chapter_43'
 import TEXT9780062934864_CHAPTER_44 from '@/components/text/9780062934864_Chapter_44'
 import TEXT9780062934864_CHAPTER_45 from '@/components/text/9780062934864_Chapter_45'
 import TEXT9780062934864_CHAPTER_46 from '@/components/text/9780062934864_Chapter_46'
 import TEXT9780062934864_CHAPTER_47 from '@/components/text/9780062934864_Chapter_47'
 import TEXT9780062934864_CHAPTER_48 from '@/components/text/9780062934864_Chapter_48'
 import TEXT9780062934864_CHAPTER_49 from '@/components/text/9780062934864_Chapter_49'
 import TEXT9780062934864_CHAPTER_50 from '@/components/text/9780062934864_Chapter_50'
 import TEXT9780062934864_CHAPTER_51 from '@/components/text/9780062934864_Chapter_51'
 import TEXT9780062934864_CHAPTER_52 from '@/components/text/9780062934864_Chapter_52'
 import TEXT9780062934864_CHAPTER_53 from '@/components/text/9780062934864_Chapter_53'
 import TEXT9780062934864_CHAPTER_54 from '@/components/text/9780062934864_Chapter_54'
 import TEXT9780062934864_CHAPTER_55 from '@/components/text/9780062934864_Chapter_55'
 import TEXT9780062934864_CHAPTER_56 from '@/components/text/9780062934864_Chapter_56'
 import TEXT9780062934864_CHAPTER_57 from '@/components/text/9780062934864_Chapter_57'
 import TEXT9780062934864_CHAPTER_58 from '@/components/text/9780062934864_Chapter_58'
 import TEXT9780062934864_CHAPTER_59 from '@/components/text/9780062934864_Chapter_59'
 import TEXT9780062934864_CHAPTER_60 from '@/components/text/9780062934864_Chapter_60'
 import TEXT9780062934864_CHAPTER_61 from '@/components/text/9780062934864_Chapter_61'
 import TEXT9780062934864_ONE_YEAR from '@/components/text/9780062934864_one_year'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780062934864_ACKNOWLEDGMENTS from '@/components/text/9780062934864_Acknowledgments'
 import TEXT9780062934864_PS_SECTION from '@/components/text/9780062934864_Ps_section'
 import TEXTABOUT_THE_AUTHOR from '@/components/text/About_the_Author'
 import TEXT9780062934864_ABOUT_THE_BOOK from '@/components/text/9780062934864_About_the_Book'
 import TEXT9780062934864_READING from '@/components/text/9780062934864_Reading'
 import TEXTLITTLE_ANNOUNCEMENT from '@/components/text/Little_Announcement'
 import TEXTLITTLE_CHAPTER_ONE from '@/components/text/Little_Chapter_One'
 import TEXTLITTLE_CHAPTER_TWO from '@/components/text/Little_Chapter_Two'
 import TEXTLITTLE_CHAPTER_THREE from '@/components/text/Little_Chapter_Three'
 import TEXT9780062934864_BOOKPERK from '@/components/text/9780062934864_Bookperk'
 import TEXT9780062934864_COPYRIGHT from '@/components/text/9780062934864_Copyright'
 import TEXTABOUT_THE_PUBLISHER from '@/components/text/About_the_Publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780062934864_Cover",
 			"name" : "text/9780062934864_Cover",
 			"component" : TEXT9780062934864_COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/text/9780062934864_Title",
 			"name" : "text/9780062934864_Title",
 			"component" : TEXT9780062934864_TITLE
 		},
 		{
 			"path" : "/text/9780062934864_Dedication",
 			"name" : "text/9780062934864_Dedication",
 			"component" : TEXT9780062934864_DEDICATION
 		},
 		{
 			"path" : "/text/9780062934864_Contents",
 			"name" : "text/9780062934864_Contents",
 			"component" : TEXT9780062934864_CONTENTS
 		},
 		{
 			"path" : "/text/9780062934864_Chapter_1",
 			"name" : "text/9780062934864_Chapter_1",
 			"component" : TEXT9780062934864_CHAPTER_1
 		},
 		{
 			"path" : "/text/9780062934864_Chapter_2",
 			"name" : "text/9780062934864_Chapter_2",
 			"component" : TEXT9780062934864_CHAPTER_2
 		},
 		{
 			"path" : "/text/9780062934864_Chapter_3",
 			"name" : "text/9780062934864_Chapter_3",
 			"component" : TEXT9780062934864_CHAPTER_3
 		},
 		{
 			"path" : "/text/9780062934864_Chapter_4",
 			"name" : "text/9780062934864_Chapter_4",
 			"component" : TEXT9780062934864_CHAPTER_4
 		},
 		{
 			"path" : "/text/9780062934864_Chapter_5",
 			"name" : "text/9780062934864_Chapter_5",
 			"component" : TEXT9780062934864_CHAPTER_5
 		},
 		{
 			"path" : "/text/9780062934864_Chapter_6",
 			"name" : "text/9780062934864_Chapter_6",
 			"component" : TEXT9780062934864_CHAPTER_6
 		},
 		{
 			"path" : "/text/9780062934864_Chapter_7",
 			"name" : "text/9780062934864_Chapter_7",
 			"component" : TEXT9780062934864_CHAPTER_7
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js